import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SubscriptionLike } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { SmtpConfigurationService } from 'src/app/services/common/SmtpConfigurationService';
import { FileData, FileService } from 'src/app/services/file.service';
import { SaEmailconfigHistoryComponent } from './sa-emailconfig-history/sa-emailconfig-history.component';
import { SaEmailconfigTestComponent } from './sa-emailconfig-test/sa-emailconfig-test.component';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailConfigurationService } from 'src/app/services/administration/EmailConfigurationService';

@Component({
  selector: 'app-super-admin-emailconfig',
  templateUrl: './super-admin-emailconfig.component.html',
  styleUrls: ['./super-admin-emailconfig.component.scss']
})
export class SuperAdminEmailconfigComponent implements OnInit {

  subUploadFile: SubscriptionLike;
  emailtypelist:any[] = [];
  SMTPConfig: UntypedFormGroup;
  @Input() public Content: any;
  fileToUpload: File | null;
  fileName: string = '';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  isFormPristine = true;
  handleFilePristine: boolean = false
  isDisable: boolean = false;
  private subinsertSMTPConfigAsync?: SubscriptionLike;
  private subfetchConfigAsync?: SubscriptionLike

  constructor(private fb: UntypedFormBuilder,
    private readonly alertify: CommonService,
    private readonly smtpService: SmtpConfigurationService,
    private readonly fileService: FileService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice :CommonService,
    private emailService: EmailConfigurationService

  ) { }
  ngOnDestroy(): void {
    if (this.subinsertSMTPConfigAsync)
      this.subinsertSMTPConfigAsync.unsubscribe();
    if (this.subfetchConfigAsync)
      this.subfetchConfigAsync.unsubscribe();
    if (this.subUploadFile)
      this.subUploadFile.unsubscribe();
  }

  ngOnInit(): void {

    this.emailtypelist.push({
      label : "Select",
      value : null , 
      checked: true

    });

    this.emailtypelist.push({
      label : "Google (G-Suite/Gmail)",
      value : 'GOOGLE'
    }); 

    this.emailtypelist.push({
      label : "Microsoft (Office 365)-Advanced",
      value : 'MICROSOFT'
    });

    this.emailtypelist.push({
      label: "Microsoft (Office 365)-Graph API",
      value: 'GRAPHAPI'
    });

   this.smtpconfigbuildForm()
   this.fetchlatestdata()
  }

  smtpconfigbuildForm() {
    this.SMTPConfig = this.fb.group({
      EmailConfigID: [null, []],
      EmailID: [null, [Validators.required, Validators.maxLength(100)]],
      EmailPwd: [null, [Validators.required, Validators.maxLength(25)]],
      EmailDisplayName: [null, [Validators.maxLength(100)]],
      EmailAccountTypeCode: [null, [Validators.required]],
      GSuiteFileID: [null, []],
      FileName: [null, []],
      FileExt: [null, []],
      MicrosoftTenantID: [null, [Validators.maxLength(1000)]],
      MicrosoftClientID: [null, [Validators.maxLength(1000)]],
      MicrosoftClientSecret: [null, [Validators.maxLength(1000)]],
      SMTPHost: [null, [Validators.required, Validators.maxLength(250)]],
      SMTPPort: [null, [Validators.required, Validators.maxLength(5)]],
      SMTPSSL: [null, []],
      UserID: [null, []],
      EmailServerStatus: [false, []],
      LoggedUserID: [null, []],
      TempFileStoreID: [null, []],
      ManageAccessToken:[false],
      ManageUserEmailID:[null, [Validators.maxLength(100)]],
      ManagerUserPassword:[null, [Validators.maxLength(100)]],
      GraphApiRead:[false],
      GraphApiSend:[false]
    });
  }

  IsAccessToken(event){
    if(event==true){
      this.SMTPConfig.controls["ManageAccessToken"].value;
    }
   if(event==false){
    this.SMTPConfig.get('ManageUserEmailID')?.setValue(null);
    this.SMTPConfig.get('ManagerUserPassword')?.setValue(null);
   }
  }
  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    }
  }

  fetchlatestdata() {
    this.subfetchConfigAsync = this.smtpService.fetchConfigAsync().subscribe(res => {
      if (res) {
        this.isDisable = true;
        this.SMTPConfig.patchValue(res);
        if (res.FileName && res.FileExt)
          this.fileName = res.FileName + res.FileExt;
      } else {
        this.SMTPConfig.controls['EmailID'].value('')
        this.SMTPConfig.controls['EmailPwd'].value('')
      }
    });

    this.SMTPConfig.valueChanges.subscribe(res => {
      this.isFormPristine = false;
    })
  }

  testSMTPConn() {
    if (this.validateSMTPTestForm()) {
      let modalRef = this.modalService.open(SaEmailconfigTestComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: '',
        content: { SMTPConfig: this.SMTPConfig.value }
      }
      modalRef.result.then(result => {
        if (result == true) {
          this.isFormPristine = result;
          this.SMTPConfig.controls['EmailServerStatus'].setValue(this.isFormPristine);
        }
      });
    }
  }

  OnVersionHistoryClick() {
    if (this.validateSMTPTestForm()) {
      let modalRef = this.modalService.open(SaEmailconfigHistoryComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: '',
        content: { SMTPConfig: this.SMTPConfig.value, ID: null }
      }
      modalRef.result.then(result => {       
      });
    }
  }

  isSMTPValid() {
    return (this.SMTPConfig.get('SMTPHost')?.valid && this.SMTPConfig.get('SMTPPort')?.valid);
  }
  isSMTPConfigValid() {
    let disable :boolean = false;    
    let type = this.SMTPConfig.get('EmailAccountTypeCode')?.value;
    
    if(type == "GRAPHAPI"){
      if(this.SMTPConfig.get('EmailID')?.valid && this.SMTPConfig.get('GraphApiSend')?.valid){
        disable = true;
      }
    } else{
      if(this.SMTPConfig.valid){
        disable = true;
      }
    }

    return disable;
  }

  ValidateForm() {
    let isValid = true;
    let err="";

    // if (!this.SMTPConfig.valid) {
      if (this.SMTPConfig.get('EmailID')?.errors?.required) {
        err="Please enter Email Address </br>";
      }
if(!(this.SMTPConfig.controls['EmailID'].value==null||this.SMTPConfig.controls['EmailID'].value==undefined||this.SMTPConfig.controls['EmailID'].value==""))
  {
    let isValidEmail = this.commonservice.validateEmail(this.SMTPConfig.controls['EmailID'].value)
    if (!isValidEmail && this.SMTPConfig.controls['EmailID'].value) {
      err+=("Please enter valid Email Address </br>");
    }
  }
      

      if (this.SMTPConfig.get('EmailID')?.errors?.maxLength) {
        err+=("Length of Email Address should not exceed 100 </br>");
      }

    if (this.SMTPConfig.controls['EmailAccountTypeCode'].value != 'GRAPHAPI') {
      if (this.SMTPConfig.get('EmailPwd')?.errors?.required) {
        err += ("Please enter Password </br>");
      }

      if (this.SMTPConfig.get('EmailPwd')?.errors?.maxLength) {
        err += ("Length of password should not exceed 25 </br>");
      }

      if (this.SMTPConfig.get('SMTPHost')?.errors?.required) {
        err += ("Please enter SMTP Host Name  </br>");
      }

      if (this.SMTPConfig.get('SMTPPort')?.errors?.required) {
        err += ("Please enter SMTP Port Number </br> ");
      }
    }

      if (this.SMTPConfig.get('EmailAccountTypeCode')?.errors?.required || this.SMTPConfig.get('EmailAccountTypeCode')?.value == null) {
        err+=("Please select Email Account type </br>");
      }
    // }

    if (this.SMTPConfig.get('EmailAccountTypeCode')?.errors == null) {
      let atVal = this.SMTPConfig.get('EmailAccountTypeCode')?.value;
      if (atVal) {
        if (atVal === 'GOOGLE') {
          if (this.SMTPConfig.get('GSuiteFileID')?.value == null && this.SMTPConfig.get('EmailConfigID')?.value == null && this.SMTPConfig.get('TempFileStoreID')?.value == null) {
            err+=("Please upload google (g-suite/gmail) file </br>");
          } else if (this.SMTPConfig.get('GSuiteFileID')?.value == null && this.SMTPConfig.get('EmailConfigID')?.value != null && this.SMTPConfig.get('TempFileStoreID')?.value == null) {
            err+=("Please upload google (g-suite/gmail) file  </br>");
          }
        }
        if (atVal === 'MICROSOFT') {
          if (this.SMTPConfig.controls['MicrosoftTenantID'].value == "" || this.SMTPConfig.controls['MicrosoftTenantID'].value == null || this.SMTPConfig.controls['MicrosoftTenantID'].value ==undefined) {
            err+=("Please enter Tenant ID </br>");
          }
          if (this.SMTPConfig.controls['MicrosoftClientID'].value =="" || this.SMTPConfig.controls['MicrosoftClientID'].value == null || this.SMTPConfig.controls['MicrosoftClientID'].value == undefined) {
            err+=("Please enter Client ID </br>");
          }
          if (this.SMTPConfig.controls['MicrosoftClientSecret'].value == "" || this.SMTPConfig.controls['MicrosoftClientSecret'].value == null || this.SMTPConfig.controls['MicrosoftClientSecret'].value == undefined) {
            err+=("Please enter Client secret </br>");
          }
        }
      }
    }

    
    if(this.SMTPConfig.controls['EmailAccountTypeCode'].value =='GRAPHAPI'){
      if (this.SMTPConfig.controls['MicrosoftTenantID'].value == "" || this.SMTPConfig.controls['MicrosoftTenantID'].value == null ||  this.SMTPConfig.controls['MicrosoftTenantID'].value == undefined) {
        err+=("Please enter Tenant ID </br>");
      }
      if (this.SMTPConfig.controls['MicrosoftClientID'].value == "" || this.SMTPConfig.controls['MicrosoftClientID'].value == null || this.SMTPConfig.controls['MicrosoftClientID'].value == undefined) {
        err+=("Please enter Client ID </br>");
      }
      if (this.SMTPConfig.controls["MicrosoftClientSecret"].value  == "" || this.SMTPConfig.controls["MicrosoftClientSecret"].value == null || this.SMTPConfig.controls["MicrosoftClientSecret"].value == undefined) {
        err+=("Please enter Client secret </br>");
      }

      if((this.SMTPConfig.controls['GraphApiRead'].value == "" || this.SMTPConfig.controls['GraphApiRead'].value == null ||  this.SMTPConfig.controls['GraphApiRead'].value == undefined)&&
    (this.SMTPConfig.controls['GraphApiSend'].value == "" || this.SMTPConfig.controls['GraphApiSend'].value == null ||  this.SMTPConfig.controls['GraphApiSend'].value == undefined)){
      err+=("Please select data in Graph API details to save the details");
      }
    }

    if(this.SMTPConfig.controls['ManageAccessToken'].value){
      if (this.SMTPConfig.controls['ManageUserEmailID'].value==""||this.SMTPConfig.controls['ManageUserEmailID'].value==null||this.SMTPConfig.controls['ManageUserEmailID'].value==undefined) {
        err+=("Please enter Manage User Email Address</br>");
      }

      let isValidEmail = this.commonservice.validateEmail(this.SMTPConfig.controls['ManageUserEmailID'].value)
      if (!isValidEmail && this.SMTPConfig.controls['ManageUserEmailID'].value) {
        err+=("Please enter valid Manage User Email Address</br>");
      }

      if (this.SMTPConfig.controls['ManageUserEmailID']?.errors?.maxLength) {
        err+=("Length of Manage User Email Address should not exceed 100 </br>");
      }

      if (this.SMTPConfig.controls['ManagerUserPassword'].value==""||this.SMTPConfig.controls['ManagerUserPassword'].value==null||this.SMTPConfig.controls['ManagerUserPassword'].value==undefined) {
        err+=("Please enter Manager User Password </br>");
      }

      if (this.SMTPConfig.controls['ManagerUserPassword']?.errors?.maxLength) {
        err+=("Length of Manager User Password should not exceed 100 </br>");
      }
      if(!(this.SMTPConfig.controls['EmailID'].value == null || this.SMTPConfig.controls['EmailID'].value == undefined || this.SMTPConfig.controls['EmailID'].value =="")&&!(this.SMTPConfig.controls['ManageUserEmailID'].value == null||this.SMTPConfig.controls['ManageUserEmailID'].value==undefined||this.SMTPConfig.controls['ManageUserEmailID'].value==""))
        {
          if(this.SMTPConfig.controls['EmailID'].value==this.SMTPConfig.controls['ManageUserEmailID'].value)
            {
              err+=("The Email Address and Manage user Email should be different. Please update details to save the configuration </br>");
            }
        }
    }

   /*  if (this.SMTPConfig.get('SMTPHost')?.errors?.required
      && this.SMTPConfig.get('SMTPPort')?.errors?.required
    ) {
      err+=("SMTP Details is mandatory to save the email configuration </br>");
    }
 */

    if (err && err.length > 0) {
      this.commonservice.ValidationBanner(err);
      // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: err } } });
      isValid = false;
    }
    //}

    return isValid;
  }

  validateSMTPTestForm() {
    let isValid = true;
    let err="";
    let atVal = this.SMTPConfig.get('EmailAccountTypeCode')?.value;

    if (!this.SMTPConfig.valid) {
      if(this.SMTPConfig.controls['EmailAccountTypeCode'].value=='GRAPHAPI'&&this.SMTPConfig.controls["GraphApiSend"].value==true){
        if(this.SMTPConfig.controls['EmailID'].value==null||this.SMTPConfig.controls['EmailID'].value==undefined||this.SMTPConfig.controls['EmailID'].value==""){
          err+=("Please enter Email Address </br>");
        }
      }
      else if (this.SMTPConfig.get('EmailID')?.errors?.required) {
        err+=("Please enter Email Address </br>");
      }
     
      if (atVal != "GRAPHAPI") {
       

        if (this.SMTPConfig.get('EmailPwd')?.errors?.required) {
          err += ("Please enter password </br>");
        }

        if (this.SMTPConfig.get('EmailPwd')?.errors?.maxLength) {
          err += ("Length of password should not exceed 25 </br>");
        }
      }

      if (this.SMTPConfig.get('EmailAccountTypeCode')?.errors?.required || this.SMTPConfig.get('EmailAccountTypeCode')?.value == null || this.SMTPConfig.get('EmailAccountTypeCode')?.value == "-1" ) {
        err+=("Please select Email account type </br>");
      }
    }
    if(!(this.SMTPConfig.controls['EmailID'].value==null||this.SMTPConfig.controls['EmailID'].value==undefined||this.SMTPConfig.controls['EmailID'].value=="")){
      let isemailvalid = this.commonservice.validateEmail(this.SMTPConfig.controls['EmailID'].value)
      if (!isemailvalid) {
        err+=("Please enter valid Email Address </br>");
      }
    }
    if (this.SMTPConfig.get('EmailID')?.errors?.maxLength) {
      err += ("Length of Email Address should not exceed 100 </br>");
    }
    if (this.SMTPConfig.get('EmailAccountTypeCode')?.errors == null) {
      let atVal = this.SMTPConfig.get('EmailAccountTypeCode')?.value;
      if (atVal) {
        if (atVal === 'GOOGLE') {
          if (this.SMTPConfig.get('GSuiteFileID')?.value == null && this.SMTPConfig.get('EmailConfigID')?.value == null && this.SMTPConfig.get('TempFileStoreID')?.value == null) {
            err+=("Please upload google (g-suite/gmail) file </br>");
          } else if (this.SMTPConfig.get('GSuiteFileID')?.value == null && this.SMTPConfig.get('EmailConfigID')?.value != null && this.SMTPConfig.get('TempFileStoreID')?.value == null) {
            err+=("Please upload google (g-suite/gmail) file </br>");
          }
        }
        if (atVal === 'MICROSOFT'||atVal ==='GRAPHAPI') {
          if (this.SMTPConfig.controls['MicrosoftTenantID'].value == "" || this.SMTPConfig.controls['MicrosoftTenantID'].value == null || this.SMTPConfig.controls['MicrosoftTenantID'].value ==undefined) {
            err+=("Please enter Tenant ID </br>");
          }
          if (this.SMTPConfig.controls['MicrosoftClientID'].value =="" || this.SMTPConfig.controls['MicrosoftClientID'].value == null || this.SMTPConfig.controls['MicrosoftClientID'].value == undefined) {
            err+=("Please enter Client ID </br>");
          }
          if (this.SMTPConfig.controls['MicrosoftClientSecret'].value == "" || this.SMTPConfig.controls['MicrosoftClientSecret'].value == null || this.SMTPConfig.controls['MicrosoftClientSecret'].value == undefined) {
            err+=("Please enter Client secret </br>");
          }
        }
      }
    } 
    if(this.SMTPConfig.controls['ManageAccessToken'].value){
      if (this.SMTPConfig.controls['ManageUserEmailID'].value==""||this.SMTPConfig.controls['ManageUserEmailID'].value==null||this.SMTPConfig.controls['ManageUserEmailID'].value==undefined) {
        err+=("Please enter Manage User Email Address </br>");
      }
     if (this.SMTPConfig.controls['ManagerUserPassword'].value==""||this.SMTPConfig.controls['ManagerUserPassword'].value==null||this.SMTPConfig.controls['ManagerUserPassword'].value==undefined) {
      err+=("Please enter Manager User Password </br>");
    }
    if(!(this.SMTPConfig.controls['ManagerUserPassword'].value==""||this.SMTPConfig.controls['ManagerUserPassword'].value==null||this.SMTPConfig.controls['ManagerUserPassword'].value==undefined)){
          if (this.SMTPConfig.controls['ManagerUserPassword']?.errors?.maxLength) {
            err+=("Length of Manager User Password should not exceed 100 </br>");
          }
      }
      if(!(this.SMTPConfig.controls['ManageUserEmailID'].value==null||this.SMTPConfig.controls['ManageUserEmailID'].value==undefined||this.SMTPConfig.controls['ManageUserEmailID'].value=="")){
        let isemailvalid = this.commonservice.validateEmail(this.SMTPConfig.controls['ManageUserEmailID'].value)
        if (!isemailvalid) {
          err+=("Please enter valid Manage User Email Address </br>");
        }
      }
  }   
   
    if (atVal != "GRAPHAPI") {
      if (this.SMTPConfig.get('SMTPHost')?.errors?.required) {
        err += ("Please enter smtp host name </br>");
      }

      if (this.SMTPConfig.get('SMTPPort')?.errors?.required) {
        err += ("Please enter smtp port number </br>");
      }
    }

    if (err && err.length > 0) {
      this.commonservice.ValidationBanner(err);
      isValid = false;
    }

    return isValid;
  }

  typeChange(event) {
    if (event ) {
      var type = this.SMTPConfig.get('EmailAccountTypeCode')?.value;
      if (type) {
        if (type === 'GOOGLE') {
          
          this.SMTPConfig.get('MicrosoftTenantID')?.setValue(null);
          this.SMTPConfig.get('MicrosoftClientID')?.setValue(null);
          this.SMTPConfig.get('MicrosoftClientSecret')?.setValue(null);
          this.SMTPConfig.get('ManageAccessToken')?.setValue(false);
          this.SMTPConfig.get('ManageUserEmailID')?.setValue(null);
          this.SMTPConfig.get('ManagerUserPassword')?.setValue(null);
          this.fileName = "";
         }
         if (type === 'MICROSOFT') {
          
          this.SMTPConfig.get('TempFileStoreID')?.setValue(null);
          this.SMTPConfig.get('GSuiteFileID')?.setValue(null);
          this.SMTPConfig.get('FileName')?.setValue(null);
          this.SMTPConfig.get('FileExt')?.setValue(null);
          this.SMTPConfig.get('GraphApiRead').setValue(false);
          this.SMTPConfig.get('GraphApiSend').setValue(false);
          this.SMTPConfig.get('MicrosoftTenantID')?.setValue(null);
          this.SMTPConfig.get('MicrosoftClientID')?.setValue(null);
          this.SMTPConfig.get('MicrosoftClientSecret')?.setValue(null);
        }

        if(type === "GRAPHAPI"){
          
          this.SMTPConfig.get('SMTPHost').setValue(null);
          this.SMTPConfig.get('SMTPPort').setValue(null); 
          this.SMTPConfig.get('MicrosoftTenantID')?.setValue(null);
          this.SMTPConfig.get('MicrosoftClientID')?.setValue(null);
          this.SMTPConfig.get('MicrosoftClientSecret')?.setValue(null);
          this.SMTPConfig.get('ManageAccessToken')?.setValue(false);
          this.SMTPConfig.get('ManageUserEmailID')?.setValue(null);
          this.SMTPConfig.get('ManagerUserPassword')?.setValue(null);         
        }
      }
    }
  }

  private validateFile() {

    let isValidFile = true;
    var err: any = [];
    let fileSize = 25;
    let fileType = this.fileToUpload?.name.substring(this.fileToUpload?.name.length - 4, this.fileToUpload.name.length);
    fileType = fileType?.toLowerCase();
    if (!(fileType === "json")) {
      isValidFile = false;
      err.push('The file type permitted to upload is .json. Please select another file type to upload </br>');
    }
    if (this.fileToUpload != null && this.fileToUpload.size > (fileSize * 1048576)) {
      isValidFile = false;
      err.push(`Json size cannot be more than ${fileSize} MB </br>`);
    }
    if (this.fileToUpload != null && this.fileToUpload.name != null && this.fileToUpload.name.length > 250) {
      isValidFile = false;
      err.push('File name cannot be more than 250 characters </br>');
    }

    if (!isValidFile) {
      this.commonservice.ValidationBanner(err);

    }
    return isValidFile;
  }

  handleFile(event: any) {//:FileList) {
    let files = event?.target?.files;
    if (files.length > 0) {
      this.fileToUpload = files.item(0);
      let fileId: string | undefined;

      if (this.validateFile() && this.fileToUpload) {

        fileId = 'null'
        this.subUploadFile = this.smtpService.uploadFile(this.fileToUpload, fileId).subscribe(
          (result: FileData) => {
            this.SMTPConfig.get('TempFileStoreID')?.setValue(result.FileID);
            this.SMTPConfig.get('FileName')?.setValue(result.FileName);
            this.SMTPConfig.get('FileExt')?.setValue(result.FileExt);
            this.SMTPConfig.get('FileBytes')?.setValue(result.FileBytes);
            this.handleFilePristine = true;
            if (result.FileName && result.FileExt)
              this.fileName = result.FileName + result.FileExt;
          },
          err => {
            this.commonservice.ValidationBanner(err);

          });
      }
    }
  }

  SaveSMTPConfig() {
    if (this.ValidateForm()) {
      if (!this.SMTPConfig.pristine && this.SMTPConfig.dirty) {
        var IsEmailStatus = this.SMTPConfig.controls['EmailServerStatus'].value;
        if (!IsEmailStatus){
          this.SMTPConfig.controls['EmailServerStatus'].setValue(true);
        }
        this.InsertUpdateSMTPConfig()
      }
      else {
        if (this.handleFilePristine) {
          this.InsertUpdateSMTPConfig()

        } else {
          this.commonservice.ValidationBanner("No changes have been performed");
        }
      }
    }
  }

  InsertUpdateSMTPConfig() {
    const formdata= this.SMTPConfig.value;
    formdata.ManageAccessToken=formdata.ManageAccessToken==false?0:1;
    this.subinsertSMTPConfigAsync = this.smtpService.insertConfigAsync(this.SMTPConfig.value).subscribe(result => {
      if (result != null && result != undefined) {
        if (result.Status==0) {
          this.commonservice.SuccessBanner(result.Message);
          this.handleFilePristine = false;
          this.fetchlatestdata();
          this.SMTPConfig.markAsPristine();
        } else {
          if (result.Message != '') {
            let message = "";
            $("#NAME").addClass("ng-touched ng-invalid validate-error");
            $("#NAME").removeClass("ng-untouched ng-valid");
            message= result.Message
            this.commonservice.ValidationBanner(message);
          }
        }
      }
      else {
        let err: any = [];
        err.push("Unable to save");
        this.commonservice.ValidationBanner(err);
      }
    },
      err => {
       this.commonservice.ValidationBanner(err);
      });
  }

  isReadValid(){
    return this.SMTPConfig.controls["GraphApiRead"].value;
  }

  isSendValid(){
    return this.SMTPConfig.controls["GraphApiSend"].value;
  }

  IsReadChecked(event){
    if(event==true){
      this.SMTPConfig.controls["GraphApiRead"].value;
    }    
  }

  IsSendChecked(event){
    if(event==true){
      this.SMTPConfig.controls["GraphApiSend"].value;
    }    
  }

  testGraphSendConn() {
    if (this.validateSMTPTestForm()){
      let modalRef = this.modalService.open(SaEmailconfigTestComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: '',
        content: { SMTPConfig: this.SMTPConfig.value, type: 'Graph' }
      }
      modalRef.result.then(result => {
        if (result == true) {
          this.isFormPristine = result;
          this.SMTPConfig.controls['EmailServerStatus'].setValue(this.isFormPristine);
        }
      });    
    }
    }
    
}
